import { render, staticRenderFns } from "./NbQuizRootView.vue?vue&type=template&id=2b17b16c"
import script from "./NbQuizRootView.vue?vue&type=script&lang=js"
export * from "./NbQuizRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports